import { TravelHistoryMessages, TranslationTravelHistoryMessages } from "../interfaces";

export const messages: TranslationTravelHistoryMessages = {

  // region Travel History
  [TravelHistoryMessages.time]: "time",
  [TravelHistoryMessages.distance]: "Distance",
  [TravelHistoryMessages.durationInMinutes]: "Duration (in minutes)",
  [TravelHistoryMessages.distanceInKilometers]: "Distance (in kilometers)",
  [TravelHistoryMessages.document]: "Doc.",
  [TravelHistoryMessages.origin]: "Origin",
  [TravelHistoryMessages.destination]: "Destination",
  [TravelHistoryMessages.finishPoint]: "Finish point",
  [TravelHistoryMessages.travelHistoryTitle]: "Travel history",
  [TravelHistoryMessages.travels]: "Travels",
  [TravelHistoryMessages.pumpReportTitle]: "Pump report",
  [TravelHistoryMessages.coordinatesTitle]: "Coordinates",
  [TravelHistoryMessages.client]: "Client",
  [TravelHistoryMessages.constructionEntryDate]: "Construction entry date",
  [TravelHistoryMessages.constructionLeaveDate]: "Construction leave date",
  [TravelHistoryMessages.durationOnConstruction]: "Duration on construction",
  [TravelHistoryMessages.totalPumpingDuration]: "Total pumping duration",
  [TravelHistoryMessages.totalIdleDuration]: "Total idle duration",
  [TravelHistoryMessages.on]: "On",
  [TravelHistoryMessages.off]: "Off",
  [TravelHistoryMessages.occurrenceDate]: "Occurrence date",
  [TravelHistoryMessages.status]: "Status",
  [TravelHistoryMessages.ignition]: "Ignition",
  [TravelHistoryMessages.speed]: "Speed",
  [TravelHistoryMessages.latitude]: "Latitude",
  [TravelHistoryMessages.longitude]: "Longitude",
  [TravelHistoryMessages.address]: "Address",
  [TravelHistoryMessages.average]: "Average",
  [TravelHistoryMessages.movingAverage]: "Moving average",
  [TravelHistoryMessages.records]: "records",
  [TravelHistoryMessages.averageSpeed]: "Average speed",
  [TravelHistoryMessages.registrationDate]: "Registration date",
  [TravelHistoryMessages.intervalBetweenLastCommand]: "Interval",
  [TravelHistoryMessages.analyticReport]: "Analytic report",
  [TravelHistoryMessages.syntheticReport]: "Synthetic report",
  [TravelHistoryMessages.vehiclePlate]: "Plate",
  [TravelHistoryMessages.vehicleType]: "Vehicle type",
  [TravelHistoryMessages.plant]: "Plant",
  [TravelHistoryMessages.travelPlant]: "Plant (loading)",
  [TravelHistoryMessages.regional]: "Regional",
  [TravelHistoryMessages.group]: "Group",
  [TravelHistoryMessages.addressNotFound]: "Address not found",
  [TravelHistoryMessages.integrationReport]: "Integration report",
  [TravelHistoryMessages.mixerVehicleCode]: "Mixer vehicle code",
  [TravelHistoryMessages.noMixerRelated]: "No mixer related",
  [TravelHistoryMessages.documentNumber]: "Document number",
  [TravelHistoryMessages.startDateTransport]: "Start date transport",
  [TravelHistoryMessages.endDateTransport]: "End date transport",
  [TravelHistoryMessages.durationTransport]: "Duration transport",
  [TravelHistoryMessages.startDateLocation]: "Start date location",
  [TravelHistoryMessages.endDateLocation]: "End date location",
  [TravelHistoryMessages.durationLocation]: "Duration location",
  [TravelHistoryMessages.startDateUnload]: "Start date unload",
  [TravelHistoryMessages.endDateUnload]: "End date unload",
  [TravelHistoryMessages.durationUnload]: "Duration unload",
  [TravelHistoryMessages.startDateReturn]: "Start date return",
  [TravelHistoryMessages.endDateReturn]: "End date return",
  [TravelHistoryMessages.durationReturn]: "Duration return",
  // endregion Travel History
  // region Integration Report
  [TravelHistoryMessages.integrationReport_column_numNf]: "Doc Num",
  [TravelHistoryMessages.integrationReport_column_statusNf]: "Doc Status",
  [TravelHistoryMessages.integrationReport_column_emissionType]: "Emission Type",
  [TravelHistoryMessages.integrationReport_column_emission]: "Emission",
  [TravelHistoryMessages.integrationReport_column_integration]: "Integration",
  [TravelHistoryMessages.integrationReport_column_loadGroup]: "Load Group",
  [TravelHistoryMessages.integrationReport_column_vehicle]: "Vehicle (Plate)",
  [TravelHistoryMessages.integrationReport_column_driverCode]: "Driver (Code)",
  [TravelHistoryMessages.integrationReport_column_driverDocument]: "Driver (Document)",
  [TravelHistoryMessages.integrationReport_column_origin]: "Origin",
  [TravelHistoryMessages.integrationReport_column_destination]: "Destination",
  [TravelHistoryMessages.integrationReport_column_client]: "Client",
  [TravelHistoryMessages.integrationReport_column_productType]: "Product Type",
  [TravelHistoryMessages.integrationReport_column_errorCode]: "Error Code",
  [TravelHistoryMessages.integrationReport_loadGroupModalTitle]: "Docs in Load Group"
  // endregion Integration Report
};
